import { BEFORE_UNLOAD_BYPASS_WINDOW_MS, TECHNICAL_RELOAD_PREPARE_WINDOW_MS, NEXT_CONTROLLER_TIMEOUT_MS, SW_ACTIVATION_ACK_TIMEOUT_MS } from "../config/swConfig";

export function allowTechnicalReloadWindow(clientVersion, windowMs = BEFORE_UNLOAD_BYPASS_WINDOW_MS) {
  try {
    const until = Date.now() + Math.max(3000, Number(windowMs) || BEFORE_UNLOAD_BYPASS_WINDOW_MS);
    window.__fzBypassBeforeUnload = true;
    window.__fzBypassBeforeUnloadUntil = until;
    window.__fzTechnicalUpdateInProgress = true;
    window.__fzBootSplashVisible = true;
    try { sessionStorage.setItem(`fz:bypassBeforeUnloadUntil:${clientVersion}`, String(until)); } catch (_) {}
    try { sessionStorage.setItem(`fz:technicalUpdateInProgress:${clientVersion}`, '1'); } catch (_) {}
    try { sessionStorage.setItem(`fz:technicalUpdateIntent:${clientVersion}`, '1'); } catch (_) {}
    try { sessionStorage.setItem(`fz:versionBoot:${clientVersion}`, String(Date.now())); } catch (_) {}
    try { localStorage.setItem('fz:update:attempted', '1'); } catch (_) {}
  } catch (e) {}
}

export function buildUpdateUrl(targetVersion, href = "") {
  const base = String(href || window.location.href || "").split("?")[0];
  return `${base}?update=${Date.now()}&v=${encodeURIComponent(String(targetVersion || ""))}`;
}

export async function softReloadToLatest({
  targetVersion = "",
  clientVersion = "",
  skipPrepare = false,
  prepareRefresh,
  allowReloadWindow = allowTechnicalReloadWindow,
} = {}) {
  const cleanUrl = buildUpdateUrl(targetVersion || clientVersion, window.location.href);
  try { sessionStorage.setItem("fz:update:attempted", "1"); } catch (e) {}
  allowReloadWindow(clientVersion || targetVersion, TECHNICAL_RELOAD_PREPARE_WINDOW_MS);
  if (!skipPrepare) {
    try {
      if (typeof prepareRefresh === "function") {
        await prepareRefresh(targetVersion || clientVersion);
      }
    } catch (e) {}
  }
  try {
    window.location.replace(cleanUrl);
  } catch (e) {
    try { window.location.href = cleanUrl; } catch (_) {}
  }
}

export async function waitForNextController(timeoutMs = NEXT_CONTROLLER_TIMEOUT_MS) {
  await new Promise((resolve) => {
    let settled = false;
    let timeout = null;
    const done = () => {
      if (settled) return;
      settled = true;
      try { if (timeout) clearTimeout(timeout); } catch (e) {}
      try { navigator.serviceWorker?.removeEventListener?.("controllerchange", onControllerChange); } catch (e) {}
      resolve();
    };
    const onControllerChange = () => {
      try { setTimeout(done, 500); } catch (e) { done(); }
    };
    try {
      timeout = setTimeout(done, timeoutMs);
      navigator.serviceWorker?.addEventListener?.("controllerchange", onControllerChange, { once: true });
    } catch (e) {
      done();
    }
  });
}

export async function waitForServiceWorkerActivationAck(expectedVersion = "", timeoutMs = SW_ACTIVATION_ACK_TIMEOUT_MS) {
  return await new Promise(async (resolve) => {
    let settled = false;
    let timeout = null;
    const done = (matched = false) => {
      if (settled) return;
      settled = true;
      try { if (timeout) clearTimeout(timeout); } catch (e) {}
      try { navigator.serviceWorker?.removeEventListener?.("message", onMessage); } catch (e) {}
      resolve(matched);
    };
    const onMessage = (event) => {
      try {
        const data = event?.data || {};
        const type = String(data?.type || "");
        const version = String(data?.version || "");
        if (type !== "SW_ACTIVE" && type !== "SW_STATUS") return;
        if (!expectedVersion || !version || version === expectedVersion) {
          done(true);
        }
      } catch (e) {}
    };
    try {
      timeout = setTimeout(() => done(false), timeoutMs);
      navigator.serviceWorker?.addEventListener?.("message", onMessage);
      const reg = await navigator.serviceWorker?.getRegistration?.();
      try { navigator.serviceWorker?.controller?.postMessage?.({ type: "REQUEST_STATUS" }); } catch (e) {}
      try { navigator.serviceWorker?.controller?.postMessage?.({ type: "PING_VERSION" }); } catch (e) {}
      try { reg?.active?.postMessage?.({ type: "REQUEST_STATUS" }); } catch (e) {}
      try { reg?.active?.postMessage?.({ type: "PING_VERSION" }); } catch (e) {}
    } catch (e) {
      done(false);
    }
  });
}
